import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    department() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/crew/department");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    position() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/crew/position");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    group() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/crew/group");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`payroll/${obj.payrollkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'compcode', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'payrolldate', 'tahunbulan', 'terminate', 'officer', 'projectid', 'projectname'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/payroll${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    paymlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'payrolldate'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/payroll/paymlist${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                // obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'payrolldate', 'tahunbulan', 'terminate', 'projectid', 'projectname'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/payroll/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Payroll_List.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportpaymlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'payrolldate'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/payroll/paymlistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PaymentList_${obj.payrolldate}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    review(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'payrolldate'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/payroll/review${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/payroll/${obj.payrollkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post('/payroll', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    process(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/payroll/process', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    cancel(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/payroll/cancel', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.payrollkey);
                url = `/payroll/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printmulti(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?payrolldate=' + encodeURIComponent(obj.payrolldate);
                if (obj.arrCrewkey) {
                    str += '&arrCrewkey=' + encodeURIComponent(JSON.stringify(obj.arrCrewkey));
                } else {
                    str += '&projectid=' + encodeURIComponent(obj.projectid);
                }
                url = `/payroll/printmulti`;
                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    email(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.payrollkey);
                url = `/payroll/email`;

                url += str;
                const { resp } = await axios.get(url);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    emailmulti(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?payrolldate=' + encodeURIComponent(obj.payrolldate);
                if (obj.arrCrewkey) {
                    str += '&arrCrewkey=' + encodeURIComponent(JSON.stringify(obj.arrCrewkey));
                } else {
                    str += '&projectid=' + encodeURIComponent(obj.projectid);
                }
                url = `/payroll/emailmulti`;
                url += str;
                const { resp } = await axios.get(url);
                resolve(resp);

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salaryitem() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/payroll/salaryitem`);
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    taxgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/crew/taxgroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    layout(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`incomestat/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`payrollslipfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout_combo() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`payrollslipfmt/combo`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    layoutDel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`payrollslipfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSave(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("payrollslipfmt", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSet(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`incomestat/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`payrollslipfmt/setting/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};